{
  "myData.export.section.heading": "Ladda ner dina uppgifter",
  "myData.export.section.description": "Du kan ladda ner de uppgifter som tjänsten har om dig. Uppgifter som hanteras i en annan tjänst ingår inte i nedladdningen utan visas som en länk.",
  "myData.export.trigger": "Ladda ner mina uppgifter",
  "myData.export.pending": "Förbereder…",
  "myData.export.ready": "Dina uppgifter är klara att laddas ner.",
  "myData.export.download.json": "Ladda ner maskinläsbar fil (JSON)",
  "myData.export.download.text": "Ladda ner läsbar fil (text)",
  "myData.export.close": "Stäng",
  "myData.export.error": "Det gick inte att ladda ner dina uppgifter. Försök igen."
}
